import AddPrescriberPage from './AddPrescriberPage'

export default AddPrescriberPage
